import { render, staticRenderFns } from "./reset-success.vue?vue&type=template&id=673d1171&"
import script from "./reset-success.vue?vue&type=script&lang=js&"
export * from "./reset-success.vue?vue&type=script&lang=js&"
import style0 from "./reset-success.vue?vue&type=style&index=0&id=673d1171&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports